import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static targets = ["list"]

  connect() {
    this.sortable = Sortable.create(this.listTarget, {
      animation: 150,
      handle: '.drag-handle',
      onEnd: this.updatePositions.bind(this)
    })
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  }

  updatePositions(event) {
    const rows = this.listTarget.querySelectorAll('tr')
    const positions = []

    rows.forEach((row, index) => {
      const accountId = row.dataset.accountId
      if (accountId) {
        positions.push({
          id: accountId,
          position: index + 1
        })
      }
    })

    fetch('/accounts/update_positions', {
      method: 'PATCH',
      headers: {
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ positions: positions })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Positions updated successfully')
      // Update the position numbers in the UI
      rows.forEach((row, index) => {
        const positionCell = row.querySelector('.position-number')
        if (positionCell) {
          positionCell.textContent = index + 1
        }
      })
    })
    .catch(error => {
      console.error('Error updating positions:', error)
      alert('Failed to update positions. Please refresh the page.')
    })
  }
}

